import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import _ from 'lodash';
import Tooltip from '../tooltip';
import InputValidationErrorSymbol from '../inputValidationError.svg.js';
import InputValidationSuccessSymbol from '../inputValidationSuccess.svg.js';
import TextLabel from '../textLabel';
import { dataHooks } from './constants';
import InfoIcon from '../infoIcon';
import classNames from 'classnames';
export default function () {
  return /*#__PURE__*/React.createElement("div", {
    className: this.props.getClassName(this.getRootCssClasses()),
    "data-aid": this.props.automationId,
    "data-hook": this.props.dataHook,
    onClick: this.props.onClick
  }, this.props.prefix || this.props.infoIcon ? /*#__PURE__*/React.createElement("label", {
    htmlFor: this.uniqueId,
    key: "inputPrefix",
    className: classNames('input-prefix', {
      clickable: this.props.focusOnPrefixClick,
      'with-info-icon': this.props.infoIcon
    })
  }, /*#__PURE__*/React.createElement(TextLabel, {
    value: this.props.prefix,
    shouldTranslate: this.props.shouldTranslate,
    className: "input-prefix-text"
  }), this.props.infoIcon && /*#__PURE__*/React.createElement(InfoIcon, _extends({
    className: "infoIcon"
  }, this.props.infoIcon))) : null, this.refs.input && this.props.showInfoTooltip ? /*#__PURE__*/React.createElement(Tooltip, _.assign({}, {
    key: 'input-info',
    className: 'input-info',
    customTrigger: this.refs.input
  }, this.props.infoTooltipProps)) : null, /*#__PURE__*/React.createElement("input", _extends({}, this.getInputProps(), {
    "data-hook": dataHooks.TextInputTag
  })), this.props.inputTextSuffix ? /*#__PURE__*/React.createElement("span", {
    className: "input-text-suffix",
    key: "inputTextSuffix",
    "data-hook": dataHooks.inputTextSuffix
  }, this.props.inputTextSuffix) : null, this.props.invalidMessage ? /*#__PURE__*/React.createElement(Tooltip, {
    isOpen: this.props.tooltipIsOpen,
    content: this.props.invalidMessage,
    interactive: this.props.tooltipInteractive,
    shouldTranslate: _.isUndefined(this.props.shouldTranslateError) ? this.props.shouldTranslate : this.props.shouldTranslateError,
    alignment: this.props.tooltipAlignment,
    key: "validationErrorSymbol",
    className: "input-validation-icon"
  }, /*#__PURE__*/React.createElement("span", {
    "data-aid": "input-error-indication",
    "data-hook": dataHooks.errorIndication,
    className: "input-validation-icon-inner"
  }, /*#__PURE__*/React.createElement(InputValidationErrorSymbol, null))) : null, this.props.success ? /*#__PURE__*/React.createElement("span", {
    className: "input-validation-icon",
    key: "validationSuccessSymbol"
  }, /*#__PURE__*/React.createElement("span", {
    className: "input-validation-icon-inner"
  }, /*#__PURE__*/React.createElement(InputValidationSuccessSymbol, null))) : null);
}